/* Size Guide — tab switching */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('button.sg-tab').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var t = btn.dataset.t;

      // Update tab active states
      document.querySelectorAll('button.sg-tab').forEach(function (b) {
        b.classList.toggle('sg-on', b === btn);
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });

      // Show matching panel, hide others
      document.querySelectorAll('.sg-panel').forEach(function (p) {
        p.classList.toggle('sg-on', p.id === 'sg-' + t);
      });
    });
  });
});
